<script setup lang="ts">
const router = useRouter();
const route = useRoute();

type ListingFilter = {
  id: string;
  code: string;
  label: string;
  name: string;
};

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters?: any;
}>();

const shipping = computed({
  get: () => props.selectedFilters[props.filter?.code],
  set: (newValue: boolean) => {
    router.push({
      query: { ...route.query, p: 1, "shipping-free": newValue || undefined },
    });

    return newValue;
  },
});
</script>

<template>
  <div class="flex justify-between gap-2">
    <h3 class="font-medium text-gray-600">{{ $t("filter.shipping-free") }}</h3>

    <ToggleSwitch v-model="shipping" :arial-label="props.filter.name" />
  </div>
</template>
